export default {"src":"/_next/static/media/requirements.8859ee97.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};